<template>
  <div class="players">
    <div class="content-wrapper">
      <RouterView />
    </div>
  </div>
</template>
